import React from 'react';
import Header from './commonComponents/header/header';
import Sidebar from './commonComponents/sidebar';
import Router from './routes';
import useAuthContext from './hooks/useAuthContext';

const Layout = () => {
    const { user, isAuthenticated } = useAuthContext();
    console.log('Layout', { user });

    return (
        <div className="layout-main">
            {user && <Header user={user} />}
            <div className="d-flex">
                {user && <Sidebar user={user} />}
                <div
                    className="container-block w-100"
                    style={{
                        padding: '10px',
                    }}
                >
                    <Router user={user} />
                </div>
            </div>
        </div>
        // <div className="layout-main">
        //   {user && <Header />}
        //   <div className="d-flex">
        //     {user && <Sidebar />}
        //     <div className="container-block w-100" style={{
        //       padding: "10px",
        //       backgroundColor: "green"
        //     }}>
        //       <Router />
        //     </div>
        //   </div>
        // </div>
    );
};

export default Layout;
